<template>
	<object
		id="controller-status-svg"
		:onload="loaded()"
		:data="image"
		type="image/svg+xml"
		:height="size"
		:width="size"
	></object>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

export default {
	data() {
		return {
			image: require("@/assets/technician.svg"),
			elements: [
				"server-circle-top",
				"server-circle-middle",
				"server-circle-bottom",
				"server-circle-flashing",
			],
		};
	},
	computed: {
		...mapState("controller", ["status"]),
		...mapGetters("controller", ["states"]),
		size() {
			return this.$vuetify.breakpoint.xsOnly ? 75 : 150;
		},
	},
	watch: {
		status(val) {
			setTimeout(() => {
				this.update();
			}, 500);
		},
	},
	methods: {
		loaded() {
			setTimeout(() => {
				this.update();
			}, 500);
		},
		update() {
			switch (this.status) {
				case this.states.NOT_AVAILABLE:
				case this.states.NOT_FOUND:
					this.red();
					break;
				case this.states.UNKNOWN:
					this.flashingRed();
					break;
				case this.states.DISCOVERED:
					this.yellow();
					break;
				case this.states.CONNECTED:
					this.green();
					break;
			}
		},
		flashingRed() {
			this.addClass("server-circle-flashing", "server-circle-visible");
		},

		red() {
			this.addClass("server-circle-bottom", "server-circle-red");
		},
		yellow() {
			this.addClass("server-circle-middle", "server-circle-yellow");
		},
		green() {
			this.addClass("server-circle-top", "server-circle-green");
		},

		addClass(id, cls) {
			let svg = document.getElementById("controller-status-svg");
			if (!svg) {
				return;
			}

			// reset all
			this.reset();

			let el = svg.contentDocument.getElementById(id);
			el.classList.add(cls);

			if (id === "server-circle-flashing") {
				el.classList.remove("server-circle-hidden");
			}
		},

		reset() {
			let svg = document.getElementById("controller-status-svg");
			_.each(this.elements, id => {
				let el = svg.contentDocument.getElementById(id);
				el.classList = ["server-circle "];

				if (id === "server-circle-flashing") {
					el.classList.add("server-circle-hidden");
				}
			});
		},
	},
};
</script>

<style></style>
